<template>
  <div class="bg-white-900 mb-14 mt-2">
    <div class="container mx-auto">
      <base-breadcrumbs :links-list="breadcrumbsList" class="mb-6" />
      <h1 class="capitalize text-5xl text-black-900 mb-5">
        Shortlist of Epigram Bookshops Catalogs
      </h1>
      <actions-bar
        select-type="books"
        title="Books total: 340"
        title-class="text-2xl"
        placeholder="Search by name, author, ISBN"
      />
      <list-books class="mb-13" />
    </div>
    <sticky-buttons />
  </div>
</template>

<script>
import ActionsBar from "@/components/base/ActionsBar.vue";
import Breadcrumbs from "@/components/base/Breadcrumbs.vue";
import StickyButtons from "@/components/base/StickyButtons.vue";
import TabBooks from "@/components/tabs/Books.vue";

export default {
  name: "ShortlistBooks",
  components: {
    "actions-bar": ActionsBar,
    "base-breadcrumbs": Breadcrumbs,
    "sticky-buttons": StickyButtons,
    "list-books": TabBooks,
  },
  data() {
    return {
      breadcrumbsList: [
        {
          href: "/shortlist",
          text: "Shortlist",
        },
        {
          href: "/shortlist/1/books",
          text: "Epigram Bookshops Books",
        },
      ],
    };
  },
};
</script>
